import { TimelineLocationContent } from '@/components/Timeline';
import { AddLocationTicketEvent } from '@certhon/models';

interface LocationContentProps {
  event: AddLocationTicketEvent;
}

export function LocationContent({ event }: LocationContentProps) {
  return (
    <TimelineLocationContent
      position={event.payload.position}
      label={event.payload.label}
    />
  );
}
